import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import React from 'react';
import MaxWidth from '../Layout/MaxWidth';
import { ColorHeaderWrapper } from '../ui/Header';

export default React.memo(function CategoryHeaderLoadingState() {
  const backgroundColor = '#e2e2e2';
  return (
    <ColorHeaderWrapper>
      <MaxWidth
        style={{
          position: 'absolute',
          left: '0',
          right: '0',
          top: '0',
          bottom: '0',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LoadingLine color={backgroundColor} widthRem={16} heightPx={36} />
        <LoadingLine
          color={backgroundColor}
          widthRem={8}
          heightPx={19}
          style={{
            position: 'absolute',
            left: '2rem',
            top: '2rem',
          }}
        />
      </MaxWidth>
    </ColorHeaderWrapper>
  );
});
